// TODO: convert to ts. Task: https://leveltravel.atlassian.net/browse/LT-23380

import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { isEmpty, pickBy } from 'lodash';

import FILTERS_LIST, {
  FILTERS,
  getFiltersByPriority,
  excludeFilterByName,
} from 'src/components/Filters';

import { FiltersClear } from '../../../../FiltersClear';

import SuggestedFilters from '../../SuggestedFilters';
import FiltersApply from '../../../FiltersApply';
import FiltersSkeleton from '../../../FiltersSkeleton';
import MobileHotelFilter from '../../MobileHotelFilter';

const filterGroupCls = 'filters__filter';

class FiltersPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { rebuildCount: 0 };
  }

  componentDidUpdate(prevProps) {
    const { hasAwaitNewResults } = this.props;
    const wasUpdate = hasAwaitNewResults !== prevProps.hasAwaitNewResults;

    if (hasAwaitNewResults === false && wasUpdate) {
      this.applySuggestedFilters();
    }
  }

  getFilterData(Filter) {
    const { filters } = this.props;
    const { filterName, customFilters } = Filter;
    return customFilters
      ? pickBy(filters, (val, key) => val && customFilters.indexOf(key) !== -1)
      : filters[filterName];
  }

  getFilters() {
    const {
      changeFilter,
      clearFilter,
      filters,
      filtersPriority,
      touristsCount,
      isMobile,
      isHotelOnly,
      currencyCode,
    } = this.props;

    if (isEmpty(filters)) {
      return null;
    }

    const { rebuildCount } = this.state;

    const hotelsList = excludeFilterByName(FILTERS.FilterOperators.filterName);
    const filtersList = isHotelOnly ? hotelsList : FILTERS_LIST;
    const list = getFiltersByPriority(filtersList, filtersPriority);

    return list.map((Filter) => {
      const data = this.getFilterData(Filter);

      const { customConditionToShow } = Filter;

      if (
        isEmpty(data) ||
        (customConditionToShow && !customConditionToShow(data))
      ) {
        return null;
      }
      const { filterName } = Filter;

      return (
        <Filter
          // Forcing to remount filters after previous set of filters applied
          key={`filter-${filterName}-${rebuildCount}`}
          className={filterGroupCls}
          onChange={changeFilter}
          data={data}
          onClear={clearFilter}
          touristsCount={touristsCount}
          isMobile={isMobile}
          isHotelOnly={isHotelOnly}
          currencyCode={currencyCode}
        />
      );
    });
  }

  render() {
    const {
      hasSearchResults,
      searchComplete,
      isMobile,
      isEmptySearch,
      isHotelOnly,
      mobileHotelFilter,
    } = this.props;
    const isLoading = !searchComplete && !hasSearchResults;
    return (
      <StyledFilters
        isMobile={isMobile}
        disabled={isEmptySearch}
        className="filters"
        $isMobileHotelFilter={mobileHotelFilter}
      >
        {isLoading ? (
          <FiltersSkeleton isMobile={isMobile} />
        ) : (
          <>
            {isMobile && <MobileHotelFilter />}
            {!isHotelOnly && <SuggestedFilters isMobile={isMobile} />}

            {this.getFilters()}
            {isMobile ? <FiltersApply /> : <StyledFiltersClear />}
          </>
        )}
      </StyledFilters>
    );
  }
}

const StyledFiltersClear = styled(FiltersClear)`
  width: 100%;
`;

FiltersPanel.propTypes = {
  changeFilter: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  touristsCount: PropTypes.number.isRequired,
  searchComplete: PropTypes.bool.isRequired,
  hasSearchResults: PropTypes.bool.isRequired,
  hasAwaitNewResults: PropTypes.bool.isRequired,
  filters: PropTypes.shape({}),
  isMobile: PropTypes.bool,
};

FiltersPanel.defaultProps = {
  filters: {},
  isMobile: false,
};

const StyledFilters = styled.div`
  min-width: 220px;
  padding-bottom: 30px;

  ${({ isMobile }) =>
    isMobile &&
    `
    padding: 0;
  `}
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
  `}
  ${({ $isMobileHotelFilter }) =>
    $isMobileHotelFilter &&
    `
      height: 0;
      overflow: hidden;
`}
`;

export { FiltersPanel };
